export default __webpack_public_path__ + "static/media/palomacostapersonal.bda9600d.jpg";